const ItemType = require('@/lib/Items/ItemType');

/**
 * To prevent a circular dependency by having the require()s at the top of this file, the map of item type strings to
 * their respective entities is created at runtime. To prevent this running every time mapItemTypeToModel is called
 * the result is cached in the itemTypeModelMap variable.
 *
 * @returns {Object<string, Class|Function>}
 */
const generateItemTypeToModelMap = () => {
    let map = {};

    map[ItemType.BUNDLE] = require('@/lib/Bundles/Bundle');
    map[ItemType.DELIVERY_METHOD] = require('@/lib/Delivery/DeliveryMethod');
    map[ItemType.GIFT_VOUCHER] = require('@/lib/GiftVouchers/GiftVoucher');
    map[ItemType.ITEM_OPTION] = require('@/lib/ItemOptions/ItemOption');
    map[ItemType.MEMBERSHIP_PLAN] = require('@/lib/Memberships/MembershipPlan');
    map[ItemType.PRODUCT] = require('@/lib/Products/Product');
    map[ItemType.PRODUCT_FOOD] = require('@/lib/Products/Product');
    map[ItemType.SURCHARGE] = require('@/lib/Surcharges/Surcharge');
    map[ItemType.TICKET] = require('@/lib/Tickets/Ticket');
    map.default = require('@/lib/Items/AbstractItem');

    return map;
};

/**
 * @type {Object<string, Class|Function>|undefined}
 */
let itemTypeModelMap;

const mapItemTypeToModel = (itemType) => {
    if (itemTypeModelMap === undefined) {
        itemTypeModelMap = generateItemTypeToModelMap();
    }

    if (itemTypeModelMap.hasOwnProperty(itemType)) {
        return itemTypeModelMap[itemType];
    }

    console.warn(`Unknown item type ${itemType}`);

    // Return default item type.
    return itemTypeModelMap.default;
};

module.exports = mapItemTypeToModel;
